export const LANGUAGES = [
    { code: 'aa', name: 'Afar' },
    { code: 'ady', name: 'Adyghe' },
    { code: 'af', name: 'Afrikaans' },
    { code: 'ak', name: 'Akan' },
    { code: 'am', name: 'Amharic' },
    { code: 'ar', name: 'Arabic' },
    { code: 'arc', name: 'Official Aramaic (700-300 BCE)' },
    { code: 'as', name: 'Assamese' },
    { code: 'av', name: 'Avaric' },
    { code: 'ay', name: 'Aymara' },
    { code: 'az', name: 'Azerbaijani' },
    { code: 'ba', name: 'Bashkir' },
    { code: 'bal', name: 'Baluchi' },
    { code: 'be', name: 'Belarusian' },
    { code: 'bem', name: 'Bemba (Zambia)' },
    { code: 'ber', name: 'Berber languages' },
    { code: 'bg', name: 'Bulgarian' },
    { code: 'bh', name: 'Bihari languages' },
    { code: 'bho', name: 'Bhojpuri' },
    { code: 'bi', name: 'Bislama' },
    { code: 'bik', name: 'Bikol' },
    { code: 'bm', name: 'Bambara' },
    { code: 'bn', name: 'Bengali' },
    { code: 'br', name: 'Breton' },
    { code: 'bs', name: 'Bosnian' },
    { code: 'bua', name: 'Buriat' },
    { code: 'ca', name: 'Catalan' },
    { code: 'cau', name: 'Caucasian languages' },
    { code: 'ce', name: 'Chechen' },
    { code: 'ceb', name: 'Cebuano' },
    { code: 'ch', name: 'Chamorro' },
    { code: 'chk', name: 'Chuukese' },
    { code: 'chm', name: 'Mari (Russia)' },
    { code: 'co', name: 'Corsican' },
    { code: 'cs', name: 'Czech' },
    { code: 'cu', name: 'Church Slavic' },
    { code: 'cv', name: 'Chuvash' },
    { code: 'cy', name: 'Welsh' },
    { code: 'da', name: 'Danish' },
    { code: 'de', name: 'German' },
    { code: 'doi', name: 'Dogri (macrolanguage)' },
    { code: 'dv', name: 'Dhivehi' },
    { code: 'dz', name: 'Dzongkha' },
    { code: 'ee', name: 'Ewe' },
    { code: 'el', name: 'Modern Greek (1453-)' },
    { code: 'en', name: 'English' },
    { code: 'es', name: 'Spanish' },
    { code: 'et', name: 'Estonian' },
    { code: 'eu', name: 'Basque' },
    { code: 'fa', name: 'Persian' },
    { code: 'ff', name: 'Fulah' },
    { code: 'fi', name: 'Finnish' },
    { code: 'fil', name: 'Filipino' },
    { code: 'fj', name: 'Fijian' },
    { code: 'fo', name: 'Faroese' },
    { code: 'fr', name: 'French' },
    { code: 'fy', name: 'Western Frisian' },
    { code: 'ga', name: 'Irish' },
    { code: 'gd', name: 'Scottish Gaelic' },
    { code: 'gil', name: 'Gilbertese' },
    { code: 'gl', name: 'Galician' },
    { code: 'gn', name: 'Guarani' },
    { code: 'gu', name: 'Gujarati' },
    { code: 'gv', name: 'Manx' },
    { code: 'ha', name: 'Hausa' },
    { code: 'haw', name: 'Hawaiian' },
    { code: 'he', name: 'Hebrew' },
    { code: 'hi', name: 'Hindi' },
    { code: 'hil', name: 'Hiligaynon' },
    { code: 'ho', name: 'Hiri Motu' },
    { code: 'hr', name: 'Croatian' },
    { code: 'ht', name: 'Haitian' },
    { code: 'hu', name: 'Hungarian' },
    { code: 'hy', name: 'Armenian' },
    { code: 'hz', name: 'Herero' },
    { code: 'id', name: 'Indonesian' },
    { code: 'ig', name: 'Igbo' },
    { code: 'ilo', name: 'Iloko' },
    { code: 'inc', name: 'Indic languages' },
    { code: 'inh', name: 'Ingush' },
    { code: 'is', name: 'Icelandic' },
    { code: 'it', name: 'Italian' },
    { code: 'iu', name: 'Inuktitut' },
    { code: 'ja', name: 'Japanese' },
    { code: 'jv', name: 'Javanese' },
    { code: 'ka', name: 'Georgian' },
    { code: 'kbd', name: 'Kabardian' },
    { code: 'kg', name: 'Kongo' },
    { code: 'kk', name: 'Kazakh' },
    { code: 'kl', name: 'Kalaallisut' },
    { code: 'km', name: 'Central Khmer' },
    { code: 'kn', name: 'Kannada' },
    { code: 'ko', name: 'Korean' },
    { code: 'kok', name: 'Konkani (macrolanguage)' },
    { code: 'kos', name: 'Kosraean' },
    { code: 'kr', name: 'Kanuri' },
    { code: 'krc', name: 'Karachay-Balkar' },
    { code: 'ks', name: 'Kashmiri' },
    { code: 'ku', name: 'Kurdish' },
    { code: 'kv', name: 'Komi' },
    { code: 'ky', name: 'Kirghiz' },
    { code: 'la', name: 'Latin' },
    { code: 'lb', name: 'Luxembourgish' },
    { code: 'lg', name: 'Ganda' },
    { code: 'ln', name: 'Lingala' },
    { code: 'lo', name: 'Lao' },
    { code: 'loz', name: 'Lozi' },
    { code: 'lt', name: 'Lithuanian' },
    { code: 'lua', name: 'Luba-Lulua' },
    { code: 'lun', name: 'Lunda' },
    { code: 'lus', name: 'Lushai' },
    { code: 'lv', name: 'Latvian' },
    { code: 'mdf', name: 'Moksha' },
    { code: 'men', name: 'Mende (Sierra Leone)' },
    { code: 'mg', name: 'Malagasy' },
    { code: 'mh', name: 'Marshallese' },
    { code: 'mi', name: 'Maori' },
    { code: 'mk', name: 'Macedonian' },
    { code: 'ml', name: 'Malayalam' },
    { code: 'mn', name: 'Mongolian' },
    { code: 'mni', name: 'Manipuri' },
    { code: 'mos', name: 'Mossi' },
    { code: 'mr', name: 'Marathi' },
    { code: 'ms', name: 'Malay (macrolanguage)' },
    { code: 'mt', name: 'Maltese' },
    { code: 'mwl', name: 'Mirandese' },
    { code: 'my', name: 'Burmese' },
    { code: 'myv', name: 'Erzya' },
    { code: 'na', name: 'Nauru' },
    { code: 'nb', name: 'Norwegian Bokmål' },
    { code: 'nd', name: 'North Ndebele' },
    { code: 'ne', name: 'Nepali (macrolanguage)' },
    { code: 'niu', name: 'Niuean' },
    { code: 'nl', name: 'Dutch' },
    { code: 'nn', name: 'Norwegian Nynorsk' },
    { code: 'no', name: 'Norwegian' },
    { code: 'nog', name: 'Nogai' },
    { code: 'nr', name: 'South Ndebele' },
    { code: 'nso', name: 'Pedi' },
    { code: 'ny', name: 'Nyanja' },
    { code: 'oc', name: 'Occitan (post 1500)' },
    { code: 'om', name: 'Oromo' },
    { code: 'or', name: 'Oriya (macrolanguage)' },
    { code: 'pa', name: 'Panjabi' },
    { code: 'pag', name: 'Pangasinan' },
    { code: 'pam', name: 'Pampanga' },
    { code: 'pap', name: 'Papiamento' },
    { code: 'pau', name: 'Palauan' },
    { code: 'pl', name: 'Polish' },
    { code: 'pon', name: 'Pohnpeian' },
    { code: 'ps', name: 'Pushto' },
    { code: 'pt', name: 'Portuguese' },
    { code: 'qu', name: 'Quechua' },
    { code: 'rm', name: 'Romansh' },
    { code: 'rn', name: 'Rundi' },
    { code: 'ro', name: 'Romanian' },
    { code: 'rom', name: 'Romany' },
    { code: 'ru', name: 'Russian' },
    { code: 'rw', name: 'Kinyarwanda' },
    { code: 'sa', name: 'Sanskrit' },
    { code: 'sah', name: 'Yakut' },
    { code: 'sat', name: 'Santali' },
    { code: 'sc', name: 'Sardinian' },
    { code: 'sd', name: 'Sindhi' },
    { code: 'se', name: 'Northern Sami' },
    { code: 'sg', name: 'Sango' },
    { code: 'si', name: 'Sinhala' },
    { code: 'sid', name: 'Sidamo' },
    { code: 'sit', name: 'Sino-Tibetan languages' },
    { code: 'sk', name: 'Slovak' },
    { code: 'sl', name: 'Slovenian' },
    { code: 'sm', name: 'Samoan' },
    { code: 'sma', name: 'Southern Sami' },
    { code: 'smn', name: 'Inari Sami' },
    { code: 'sn', name: 'Shona' },
    { code: 'snk', name: 'Soninke' },
    { code: 'so', name: 'Somali' },
    { code: 'sq', name: 'Albanian' },
    { code: 'sr', name: 'Serbian' },
    { code: 'srn', name: 'Sranan Tongo' },
    { code: 'ss', name: 'Swati' },
    { code: 'st', name: 'Southern Sotho' },
    { code: 'sv', name: 'Swedish' },
    { code: 'sw', name: 'Swahili (macrolanguage)' },
    { code: 'ta', name: 'Tamil' },
    { code: 'te', name: 'Telugu' },
    { code: 'tem', name: 'Timne' },
    { code: 'tet', name: 'Tetum' },
    { code: 'tg', name: 'Tajik' },
    { code: 'th', name: 'Thai' },
    { code: 'ti', name: 'Tigrinya' },
    { code: 'tig', name: 'Tigre' },
    { code: 'tk', name: 'Turkmen' },
    { code: 'tkl', name: 'Tokelau' },
    { code: 'tl', name: 'Tagalog' },
    { code: 'tn', name: 'Tswana' },
    { code: 'to', name: 'Tonga (Tonga Islands)' },
    { code: 'tpi', name: 'Tok Pisin' },
    { code: 'tr', name: 'Turkish' },
    { code: 'ts', name: 'Tsonga' },
    { code: 'tt', name: 'Tatar' },
    { code: 'tum', name: 'Tumbuka' },
    { code: 'tut', name: 'Altaic languages' },
    { code: 'tvl', name: 'Tuvalu' },
    { code: 'tw', name: 'Twi' },
    { code: 'ty', name: 'Tahitian' },
    { code: 'tyv', name: 'Tuvinian' },
    { code: 'udm', name: 'Udmurt' },
    { code: 'ug', name: 'Uighur' },
    { code: 'uk', name: 'Ukrainian' },
    { code: 'ur', name: 'Urdu' },
    { code: 'uz', name: 'Uzbek' },
    { code: 've', name: 'Venda' },
    { code: 'vi', name: 'Vietnamese' },
    { code: 'war', name: 'Waray (Philippines)' },
    { code: 'wo', name: 'Wolof' },
    { code: 'xal', name: 'Kalmyk' },
    { code: 'xh', name: 'Xhosa' },
    { code: 'yao', name: 'Yao' },
    { code: 'yap', name: 'Yapese' },
    { code: 'yo', name: 'Yoruba' },
    { code: 'za', name: 'Zhuang' },
    { code: 'zh', name: 'Chinese' },
    { code: 'zu', name: 'Zulu' },
];

export const LANGUAGE_MAP = {};
LANGUAGES.forEach((lang) => {
    LANGUAGE_MAP[lang.code] = lang;
});
